<script setup>
/* Набор штриховых иконок навигации.

   Тонкий штрих 1.8 на сетке 24 — тот же язык, что у переключателя темы,
   иначе рядом стоящие иконки выглядят из разных наборов.

   Держим их здесь, а не в отдельных файлах: их немного, и общий набор
   гарантирует одинаковую толщину линии и скругления. */

defineProps({
  name: { type: String, required: true },
  size: { type: [Number, String], default: 22 },
});
</script>

<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <!-- Рабочее место: терминал у станка -->
    <template v-if="name === 'workplace'">
      <rect x="3" y="4" width="18" height="12" rx="2.5" />
      <path d="M9 20h6M12 16v4" />
    </template>

    <!-- Участок: сетка станков -->
    <template v-else-if="name === 'area'">
      <rect x="3.5" y="3.5" width="7" height="7" rx="1.8" />
      <rect x="13.5" y="3.5" width="7" height="7" rx="1.8" />
      <rect x="3.5" y="13.5" width="7" height="7" rx="1.8" />
      <rect x="13.5" y="13.5" width="7" height="7" rx="1.8" />
    </template>

    <!-- Заказы: документ со строками -->
    <template v-else-if="name === 'orders'">
      <path d="M6 2.8h8.5L19 7.3V21a.8.8 0 0 1-.8.8H6a.8.8 0 0 1-.8-.8V3.6A.8.8 0 0 1 6 2.8z" />
      <path d="M14 3v4.5h4.5M8.5 12.5h7M8.5 16.5h7" />
    </template>

    <!-- Вызов с рабочего места: колокол -->
    <template v-else-if="name === 'bell'">
      <path d="M18 8.6a6 6 0 1 0-12 0c0 5.2-1.8 6.6-1.8 6.6h15.6S18 13.8 18 8.6z" />
      <path d="M13.7 19a2 2 0 0 1-3.4 0" />
    </template>

    <!-- Смена: часы -->
    <template v-else-if="name === 'shift'">
      <circle cx="12" cy="12" r="8.8" />
      <path d="M12 7.2V12l3.2 2" />
    </template>

    <!-- Производство: столбчатый график -->
    <template v-else-if="name === 'production'">
      <path d="M4 20.2V13M9.3 20.2V8M14.7 20.2v-6M20 20.2V4.5" />
    </template>

    <!-- Контроль: щуп с галочкой -->
    <template v-else-if="name === 'quality'">
      <path d="M20.5 5.2 10.2 15.5l-4-4" />
      <path d="M20.6 12.2a8.6 8.6 0 1 1-5-7.8" />
    </template>

    <!-- Материалы: штабель заготовок -->
    <template v-else-if="name === 'materials'">
      <path d="M3.4 7.6 12 3.4l8.6 4.2-8.6 4.2z" />
      <path d="M3.4 12 12 16.2 20.6 12M3.4 16.4 12 20.6l8.6-4.2" />
    </template>

    <!-- Навеска: чаша весов -->
    <template v-else-if="name === 'melt'">
      <path d="M12 4.2v15.6M8.2 19.8h7.6M4.4 8.4h15.2" />
      <path d="M4.4 8.4 1.9 14.2a2.6 2.6 0 0 0 5 0zM19.6 8.4l-2.5 5.8a2.6 2.6 0 0 0 5 0z" />
    </template>

    <!-- Лаборатория: колба -->
    <template v-else-if="name === 'lab'">
      <path d="M9.5 3.5v6.2L4.6 17.8A2 2 0 0 0 6.3 20.9h11.4a2 2 0 0 0 1.7-3.1L14.5 9.7V3.5" />
      <path d="M8.2 3.5h7.6M7.3 14.6h9.4" />
    </template>

    <!-- Обслуживание: гаечный ключ -->
    <template v-else-if="name === 'maintenance'">
      <path d="M15.6 4.4a4.6 4.6 0 0 0-5.9 5.9l-5.1 5.1a1.8 1.8 0 0 0 0 2.6l1.4 1.4a1.8 1.8 0 0 0 2.6 0l5.1-5.1a4.6 4.6 0 0 0 5.9-5.9l-2.7 2.7-2.6-.7-.7-2.6z" />
    </template>

    <!-- Лом: бункер со стрелкой возврата -->
    <template v-else-if="name === 'scrap'">
      <path d="M4.6 8.6h14.8l-1.6 10.2a1.6 1.6 0 0 1-1.6 1.4H7.8a1.6 1.6 0 0 1-1.6-1.4z" />
      <path d="M9 5.6a3 3 0 0 1 5.6-.6" />
      <path d="M8.2 3.4 9 5.8l2.4-.6" />
    </template>

    <!-- Сертификат: лист с печатью -->
    <template v-else-if="name === 'certificate'">
      <path d="M19.4 11.2V5.6a1.6 1.6 0 0 0-1.6-1.6H6.2a1.6 1.6 0 0 0-1.6 1.6v12.8a1.6 1.6 0 0 0 1.6 1.6h5" />
      <path d="M8 8.4h8M8 12h5" />
      <circle cx="17.4" cy="16.6" r="3.2" />
    </template>

    <!-- Партии: бирка с отверстием под проволоку -->
    <template v-else-if="name === 'batches'">
      <path d="M10.2 3.6h8.1a2 2 0 0 1 2 2v8.1a2 2 0 0 1-.6 1.4l-4.6 4.6a2 2 0 0 1-2.8 0l-7.5-7.5a2 2 0 0 1 0-2.8l4.6-4.6a2 2 0 0 1 1.4-.6z" />
      <circle cx="15.6" cy="8.4" r="1.5" />
    </template>

    <!-- Настройка: ползунки (в референсе ровно эта иконка) -->
    <template v-else-if="name === 'settings'">
      <path d="M4 7h10M18.5 7H20M4 17h3.5M11.5 17H20" />
      <circle cx="16.2" cy="7" r="2.3" />
      <circle cx="9.3" cy="17" r="2.3" />
    </template>

    <!-- Выход -->
    <template v-else-if="name === 'logout'">
      <path d="M15.5 8V5.4a1.4 1.4 0 0 0-1.4-1.4H5.4A1.4 1.4 0 0 0 4 5.4v13.2A1.4 1.4 0 0 0 5.4 20h8.7a1.4 1.4 0 0 0 1.4-1.4V16" />
      <path d="M10 12h10M17 9l3 3-3 3" />
    </template>

    <!-- Меню карточки: четыре точки, как в референсе -->
    <template v-else-if="name === 'grip'">
      <circle cx="9.5" cy="9.5" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="14.5" cy="9.5" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="9.5" cy="14.5" r="1.3" fill="currentColor" stroke="none" />
      <circle cx="14.5" cy="14.5" r="1.3" fill="currentColor" stroke="none" />
    </template>
  </svg>
</template>
